"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let ModalComponent = class ModalComponent {
    constructor() {
        this.visible = false;
        this._visibleAnimate = false;
    }
    show() {
        this.visible = true;
        setTimeout(() => this._visibleAnimate = true);
    }
    hide() {
        this._visibleAnimate = false;
        setTimeout(() => this.visible = false, 300);
    }
};
ModalComponent = __decorate([
    core_1.Component({
        selector: 'app-modal',
        template: `
  <div class="modal fade" tabindex="-1" [ngClass]="{'in': _visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': _visibleAnimate ? 1 : 0}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <div class="modal-body">
          <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
      </div>
    </div>
  </div>
  `
    })
], ModalComponent);
exports.ModalComponent = ModalComponent;
